import { SupportMessage } from '@bridebook/aura';
import { Mail } from '@bridebook/aura/src/icons';
import { useShareAddressCollectorUrlModal } from '@bridebook/web/lib/address-collector/hooks/use-share-address-collector-url-modal';
import { Trans, useTranslation } from 'next-i18next';

interface IProps {
  onClick?: () => void;
  analyticsProps: Parameters<typeof useShareAddressCollectorUrlModal>[0];
}

export const AddressCollectorBanner = ({ analyticsProps, onClick }: IProps) => {
  const { t } = useTranslation('inbox');
  const openAddressCollectorShareModal = useShareAddressCollectorUrlModal(analyticsProps);
  const handleClick = () => {
    onClick?.();
    openAddressCollectorShareModal();
  };

  return (
    <SupportMessage
      theme="info"
      icon={Mail}
      title={t('guests.addressCollectorBanner.title')}
      onClick={handleClick}>
      <Trans ns="inbox" i18nKey="guests.addressCollectorBanner.description">
        Share <span className="text-indigo-crush">your unique link</span> with guests
      </Trans>
    </SupportMessage>
  );
};
